
  <mat-dialog-content>
    <div class="col-12" style="margin: auto; text-align: center;">
      <h1 mat-dialog-title class="naslov" style="margin-top: 7%; margin-bottom: 7%;">{{labels.lblSuccessfullyCompletedTraining}}</h1>

      <div mat-dialog-actions class="dugmeDiv" style="margin-top: 7%; margin-bottom: 7%;">
        <button mat-button (click)="onNoClick()" class="btn"
          style="width: 70%; border-radius: 11px;">{{labels.lblContinueTraining}}</button>
      </div>
    </div>
  </mat-dialog-content>
